				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class PersonService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('Person');
	}
	
	loadAll() : Observable<TooBig4Car.Logic.Person[]> {
		return this.myBaseService.loadAll(this.url);
	}
	loadAllForCustomer(id: System.Guid): Observable<TooBig4Car.Logic.Person[]> {
		return this.myBaseService.loadAll(this.url + '/ForCustomer/' + (id || ''));
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase) : Observable<TooBig4Car.Logic.Person> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid, customerID: System.Guid): Observable<TooBig4Car.Logic.Person> {
		var qs = '';
		if (!this.myBaseService.configData.IsEmptyGuid(customerID)) {
			qs = "?customerID=" + customerID;
		}
		return this.myBaseService.getWithParams(id, this.url+'/Edit', qs, false);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.Person>{
		return this.myBaseService.get(id, this.url);
	}
	sendResetPassword(id: System.Guid): Observable<string> {
		return this.myBaseService.post(null, this.url + '/ResetPassword/' + (id || ''), false);
	}

	addSupportMode(customerID: System.Guid): Observable<string> {
		return this.myBaseService.post(null, this.url + '/AddSupportMode/' + (customerID || ''), false);
	}
	removeSupportMode(): Observable<string> {
		return this.myBaseService.post(null, this.url + '/RemoveSupportMode', false);
	}
}		
